import { type OfferV11 } from '@redteclab/api/clients/bully'

export const productAccessorOfferHasSellerPromotion = (
  offer: OfferV11 | undefined,
): boolean => Boolean(offer?.sellerPromotion)
